import comp from "./ChatAttachmentsViewer";
export default comp;
